module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('div', {
    ref: "editor"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-197d5584!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyWangEditor/MyWangEditor.vue
// module id = 1645
// module chunks = 3